import { Automation } from 'domain/entity/automation';
import { CreateOrPreviewAutomationCriteria } from 'use-case/automation/create/createAutomationCriteria';
import getGenericUseCase from 'use-case/genericUseCase';

const getCreateAutomationsUseCase = getGenericUseCase<Automation, CreateOrPreviewAutomationCriteria>((client, criteria) =>
    client(criteria)
);

export default getCreateAutomationsUseCase;
